import { IconInfo16 } from '@warp-ds/icons/react/info-16';

type SortDetailsProps = {
    section: string;
    className?: string;
};

export const SortDetails = ({ section, className = '' }: SortDetailsProps) => (
    <a
        href={`https://www.finn.no/reise/info/#${section}`}
        target="_blank"
        rel="noreferrer"
        data-testid="sortDetails"
        className={`flex gap-8 items-center ${className}`}>
        <IconInfo16 aria-hidden />
        Slik sorteres søkeresultatene
    </a>
);
